import { createSelector } from '@ngrx/store';

const getLangs = (state) => state.langs;

export const getAllLangs = createSelector(getLangs, (state) => {
  const { ...langs } = state;
  return langs;
});

export const getLanguage = createSelector(getLangs, (state) => {
  return state.reg_locale.split('_')[0];
});

export const getRegLocale = createSelector(getLangs, (state) => {
  return state.reg_locale;
});

function get(obj, key) {
  return key.split('.').reduce((o, x) => {
    return (typeof o === 'undefined' || o === null) ? o : o[x];
  }, obj);
}

export const getTranslation = (keyWithAlias: string, args: string[]) => createSelector(
  getLangs,
  (state) => {
    if (keyWithAlias) {
      const value = keyWithAlias.split('.');

      let alias = 'app'; // default alias
      let key = value[0];
      // if alias is specify (e.g: common.__MY_KEY)
      if (value.length > 1) {
        [alias, key] = value;
      }

      /**
       * Return the translation or the key if translation not found
       * replace dynamic variables if needed
       */
      let translation: string;
      if (alias) {
        let i = 0;
        translation = get(state, `${alias}.${key}`)?.replace(/%s/g, () => args[i++])
          .replace(/\\n/g, '<br/>');
      }

      // Fallback to the key if translation not found
      if (!translation) {
        translation = key;
      }

      // Filter crowdin key
      return translation.match(/__[A-Z_]+/) ? '' : translation;
    }
    else {
      return '';
    }
  },
);
